import { EpicRefined } from 'interfaces/middleware'
import { AdvisorVideoCallActions, FinishMeetingAction } from 'components/features/coaching/advisorVideoCall/types/actions'
import { byType } from 'rxOperators/byType'
import { mergeMap } from 'rxjs/operators'
import { pushActionCreator, PushAction } from 'actions/navigationActions'
import { COACH_REVIEW_URL } from 'tangle-shared'
import { EMPTY, of } from 'rxjs'


export const finishMeetingEpic: EpicRefined<AdvisorVideoCallActions | PushAction> = (action$, store) => action$.pipe(
  byType(FinishMeetingAction.type),
  mergeMap(() => {
    const user = store.getState().data.advisors.videoCallDetails.details?.user ?? null
    if (!user) {
      return EMPTY
    }

    if (user.role === 'member') {
      return of(pushActionCreator({
        pathname: COACH_REVIEW_URL,
        search: location.search,
      }))
    }

    window.location.href = user.meeting_admin_url
    return EMPTY
  })
)
